import { MasterLayout } from "layout/MasterLayout";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes";
import PaymentSuccess from "pages/payment/PaymentSuccess";
import PaymentFail from "pages/payment/PaymentFail";

const PrivateMasterRoute = () => {
  return (
    <Routes>
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-fail" element={<PaymentFail />} />

      <Route element={<MasterLayout />}>
        <Route path="/*" element={<PrivateRoutes />} />
      </Route>
    </Routes>
  );
};

export default PrivateMasterRoute;
